
import { defineComponent } from 'vue';
// importing components
import SideBar from './components/SideBar.vue';
import Notifications from './components/Notifications.vue';

export default defineComponent({
  name: 'App',
  components: {
    SideBar,
    Notifications
  },
  // defining states
  data() {
    return {
      // returns an Array of Tasks
      activeDarkMode: false
    };
  },
  methods: {
    changeTheme(activeDarkMode: boolean) {
      this.activeDarkMode = activeDarkMode;
    }
  }
});
